const AdminFunctionHeaderButtonsComponent = {
    templateUrl: '/adminFunctionHeaderButtons/adminFunctionHeaderButtons.tpl.html',
    controller: 'adminFunctionHeaderButtonsController',
    bindings: {}
};

angular.module('gw-um-header')
    .component('adminFunctionHeaderButtons', AdminFunctionHeaderButtonsComponent);
